import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-inner-page" }
const _hoisted_2 = { class: "container mx-auto p-4 pb-10 md:p-8 lg:p-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" « Voltar ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "inner-page-titles" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Selecionados"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Segunda Fase"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "CNH"),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SOCIAL")
], -1)
const _hoisted_5 = { class: "text-xl leading-none" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul><li class=\"mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3\"><p class=\"mb-3 self-center\"> Relação de <span class=\"font-bold\">todos</span> os candidatos <span class=\"font-bold\">selecionados</span> em ordem alfabética </p><a href=\"files/selecionados_segundo_processo_seletivo_alfabetica.pdf\" target=\"_blank\" class=\"inline-block rounded bg-yellow-400 px-5 py-2 uppercase\"> baixar pdf </a></li></ul><h4 class=\"mb-6 mt-12 uppercase\">Relação de selecionados por município</h4>", 2)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "self-center uppercase" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Manaus")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "files/segundo_processo_seletivo_manaus.pdf",
    target: "_blank",
    class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase"
  }, " baixar pdf ")
], -1)
const _hoisted_9 = { class: "self-center uppercase" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h4 class=\"mb-6 mt-12 uppercase\">Outros</h4><ul><li class=\"mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3\"><p class=\"mb-3 self-center\"><span class=\"font-bold\">Segunda chamada</span> de candidatos selecionados no <span class=\"font-bold\">primeiro</span> processo seletivo </p><a href=\"files/primeiro_processo_seletivo_segunda_chamada_manaus.pdf\" target=\"_blank\" class=\"inline-block rounded bg-yellow-400 px-5 py-2 uppercase\"> baixar pdf </a></li></ul>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "mb-5 inline-block rounded-full bg-yellow-400 px-5 py-3 font-bold"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", null, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipios, (municipio) => {
            return (_openBlock(), _createElementBlock("li", {
              key: municipio,
              class: "mb-3 flex items-center justify-between gap-3 bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3"
            }, [
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", {
                  class: "font-bold",
                  textContent: _toDisplayString(municipio.nome)
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("a", {
                href: municipio.link,
                target: "_blank",
                class: "inline-block whitespace-nowrap rounded bg-yellow-400 px-5 py-2 uppercase"
              }, " baixar pdf ", 8, _hoisted_11)
            ]))
          }), 128))
        ]),
        _hoisted_12
      ])
    ])
  ]))
}